import { VersionReportPageConfig } from '../../../../domain/entity/version-report/VersionReportVersionEntity'

export const buildConfigJsonString = (
  config: VersionReportPageConfig
): string => {
  switch (config.type) {
    case 'PROGRESS_OVERVIEW':
      return JSON.stringify({})
    case 'PROGRESS_REPORT_BY_PROCESS':
      return JSON.stringify({})
    case 'PROGRESS_REPORT_BY_TEAM':
      return JSON.stringify({ rootUuid: config.rootUuid })
  }
}
